import { state as bannerState } from '../store/store.interactive-banner';
import { state as validationState } from '../store/store.validation';
import { LICENSE_PLATE_ERROR, MSM_STYLE_MISSING, VIN_ERRORS, VIN_LENGTH, YMM_ERRORS } from '../utils/utils.interactive-banner';
import { MAX_MILEAGE, MSM_MILEAGE_ERRORS } from '../utils/utils.vehicle';
import { isValidVin } from '../utils/utils.vin';

const onValidateBannerVin = (vin: string, isNotFound: boolean = false) => {
  const updateErrors = (errors: Set<string>) => {
    if ((vin && vin.length < VIN_LENGTH) || (vin.length == VIN_LENGTH && !isValidVin(vin))) {
      updateErrorsGroupValue(errors, VIN_ERRORS, VIN_ERRORS.VIN_LENGTH_ERROR);
    } else if (vin && isNotFound) {
      updateErrorsGroupValue(errors, VIN_ERRORS, VIN_ERRORS.VIN_NOT_FOUND_ERROR);
    } else {
      updateErrorsGroupValue(errors, VIN_ERRORS);
      return true;
    }
    return false;
  };
  return updateValidateStatusBanner(updateErrors);
};

const onValidateBannerLP = (licensePlateNumber: string, licensePlateState: string, isChanged: boolean = false): boolean => {
  const updateErrors = (errors: Set<string>): boolean => {
    if (isChanged) {
      updateErrorsGroupValue(errors, LICENSE_PLATE_ERROR);
      return true;
    } else if (!licensePlateNumber || !licensePlateState) {
      updateErrorsGroupValue(errors, LICENSE_PLATE_ERROR, LICENSE_PLATE_ERROR.LICENSE_PLATE_MISSING);
    } else {
      updateErrorsGroupValue(errors, LICENSE_PLATE_ERROR, LICENSE_PLATE_ERROR.LICENSE_PLATE_NOT_FOUND);
    }
    return false;
  };
  return updateValidateStatusBanner(updateErrors);
};

const onValidateBannerYMM = (value: string, isVehicleEligible: boolean): boolean => {
  const updateErrors = (errors: Set<string>): boolean => {
    if (!value) {
      updateErrorsGroupValue(errors, YMM_ERRORS, YMM_ERRORS.YMM_MISSING);
      return false;
    } else if (!!value && !isVehicleEligible) {
      updateErrorsGroupValue(errors, YMM_ERRORS, YMM_ERRORS.YMM_VEHICLE_NOT_ELIGIBLE);
      return false;
    }
    updateErrorsGroupValue(errors, YMM_ERRORS);
    return true;
  };
  return updateValidateStatusBanner(updateErrors);
};

const onValidateMSMStyle = (hasMultipleTrims: boolean, hasTrimId: boolean): boolean => {
  const isInvalid = hasMultipleTrims && !hasTrimId;
  const updateErrors = (errors: Set<string>) => {
    if (isInvalid) {
      errors.add(MSM_STYLE_MISSING);
      return false;
    }
    errors.delete(MSM_STYLE_MISSING);
    return true;
  };
  return updateValidateStatusBanner(updateErrors);
};

const onValidateMSMMileage = (mileage: number): boolean => {
  const updateErrors = (errors: Set<string>) => {
    if (!mileage || mileage <= 0) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.MILEAGE_MISSING);
    } else if (mileage > MAX_MILEAGE) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.INVALID_MILEAGE);
    } else {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS);
      return true;
    }
    return false;
  };
  return updateValidateStatusBanner(updateErrors);
};

const onValidateMileageRange = (mileage: number): boolean => {
  const updateErrors = (errors: Set<string>) => {
    if (bannerState.mileageRangeValidated) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS);
      return true;
    }
    if (bannerState.autoCheckMiles > 0 && bannerState.autoCheckMiles > mileage) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.LESS_THAN_MIN_MILEAGE_FROM_AUTOCHECK);
    } else if (mileage > bannerState.autoCheckMiles && bannerState.typicalMileage > 0 && mileage / bannerState.typicalMileage > 1.2) {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS, MSM_MILEAGE_ERRORS.GREATE_THAN_TYPICAL_MILEAGE);
    } else {
      updateErrorsGroupValue(errors, MSM_MILEAGE_ERRORS);
      return true;
    }
    bannerState.mileageRangeValidated = true;
    return false;
  };
  return updateValidateStatusBanner(updateErrors);
};

const updateValidateStatusBanner = (updateErrors: Function): boolean => {
  const errors = validationState.form.banner;
  const isValid = updateErrors(errors);
  validationState.form = {
    ...validationState.form,
    banner: errors,
  };
  return isValid;
};

const updateErrorsGroupValue = (errors: Set<string>, errorsGroup: object, error: string = '') => {
  Object.values(errorsGroup).map((groupError) => {
    if (groupError != error) {
      errors.delete(groupError);
    } else {
      errors.add(groupError);
    }
  });
};

const resetBannerValidationState = () => {
  validationState.form.banner.clear();
};

const actions = {
  onValidateBannerVin,
  onValidateBannerLP,
  onValidateBannerYMM,
  onValidateMSMStyle,
  onValidateMSMMileage,
  onValidateMileageRange,
  resetBannerValidationState,
};

export { actions };
export default actions;
